module.exports = __webpack_public_path__ + "static/media/Icons_IS_trigger_white.6b96243c.svg";